export default function useApi() {
    return
}

export function getEndpoint() {
    return 'https://api.menapress.org';
    // return '//localhost:3002';
}